module.exports = __webpack_public_path__ + "static/img/setting.f36c69ff.png";